// extracted by mini-css-extract-plugin
module.exports = {"header":"ActivitiesPage_header__2VutN","table":"ActivitiesPage_table__utlJF","footer":"ActivitiesPage_footer__2n7SV"};